import React, {useState, useEffect} from 'react'
import HeadingArea from '../../general/HeadingArea'
import ResponseMsg2 from '../../general/ResponseMsg2';
import { FaUserEdit } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const RegList = ({setLoading}) => {
  const [std, setStd] = useState([]);
    const [response2, setResponse2] = useState({ message: '', status: 'success' });
const [searchTerm, setSearchTerm] = useState('');
const navigate = useNavigate();


  useEffect(() => {
fetchStudents();
  }, []);
  

       const fetchStudents = async () => {
    setLoading(true);
    try {


      const url = `https://api.kcian.in/get-registration`;
      const response = await fetch(url);

      if (response.ok) {
        const data = await response.json();
        setStd(data);
      } else {
        console.error('Failed to fetch students');
      }
    } catch (error) {
      console.error('Error fetching students:', error);
    } finally {
      setLoading(false);
    }
  };


const filteredStd = std.filter(student => {
  const term = searchTerm.toLowerCase();
  const name = student.name ? student.name.toLowerCase() : '';
  const regNo = student.reg_no ? student.reg_no.toLowerCase() : '';
  return name.includes(term) || regNo.includes(term);
});


  return (
    <>
      <section className='py-4'>
        <div className='px-4'>
          <HeadingArea message1='Student' message2='Registrations' />

       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

            <div className='table-responsive mt-3'>
<table className='w-100 bg-white rounded-top-4'>

<thead className='account-thead'>
    <th className='rounded-start-4'>Enquire On</th>
    <th>Reg No</th>
    <th>Name</th>
    <th>Father Name</th>
    <th>DOB</th>
    <th>Class(Section)</th>
    <th>Gender</th>
        <th>Mobile No</th>
            <th className='rounded-end-4'>Activity</th>
</thead>


            {std.length === 0 ? (
              <tr className='text-center account-tr'><td colSpan={8}>No Student Data found</td></tr>
            ) : (
              <>
                {filteredStd.map((student) => (
  <tr className='account-tr' key={student.id}>
    <td>{student.dor_reg}</td>
    <td>{student.reg_no}</td>
    <td>{student.name}</td>
    <td>{student.father || '--'}</td>
    <td>{student.dob || '--'}</td>
<td>{student.class_name}({student.section})</td>
<td>{student.gender || '--'}</td>
<td>{student.mobile}</td>
<td>        <button className='profile-btn2' onClick={() => navigate('/admin/edit-student', {state: {student}})}>Convert Admission</button>
{/* <FaUserEdit className='emp-icon bg-primary mx-2' title='Edit' onClick={() => navigate('/admin/edit-student', {state: {student}})} /> */}
</td>
                    </tr>
                ))}
              </>
            )}

</table>
</div>


          </div>
          </section>

    </>
  )
}

export default RegList